// project imports
import { EMSMemberAccountStatus } from 'utils/constants';

// types
import { i18nEaiSubjects } from 'models/i18n';

// ==============================|| I18N SK SUBJECTS ||============================== //

const skEaiSubjects: i18nEaiSubjects = {
  createSubjectWizard: {
    title: 'Vytvorenie subjektu',
    step01: 'Údaje subjektu',
    step02: 'Rola subjektu',
    step03: 'Úroveň služieb',
    step04: 'Údaje účastníka trhu',
    save: 'Vytvoriť subjekt'
  },
  subjectDetail: {
    userData: {
      title: 'Informácie o subjekte',
      basicInfo: 'Základné informácie',
      deleteSubject: 'Zmazať subjekt'
    },
    userAccount: {
      title: 'Účty subjektu',
      account: 'Účet',
      accountState: {
        [EMSMemberAccountStatus.ACTIVE]: 'Zneplatniť účet',
        [EMSMemberAccountStatus.INACTIVE]: 'Obnoviť účet'
      },
      serviceLevelCodeHistory: 'História úrovní služieb',
      serviceLevelSpecificationId: 'Úroveň služieb'
    },
    marketParticipantData: {
      title: 'Údaje účastníka trhu',
      marketParticipantCredentials: 'Prístupy k externým službám ',
      basicInfo: 'Základné informácie',
      type: 'Typ služby',
      username: 'Používateľské meno',
      actions: 'Akcie',
      addCredentials: 'Pridať prístupové údaje'
    },
    createSubjectAccountWizard: {
      title: 'Vytvorenie účtu subjektu',
      step01: 'Rola účtu subjektu',
      step02: 'Úroveň služieb',
      step03: 'Údaje účastníka trhu',
      save: 'Vytvoriť účet subjekt'
    }
  },
  subjectList: {
    title: 'Zoznam subjektov',
    searchInput: 'Zadajte názov/EIC/RČ/IČO',
    createEntityButton: 'Vytvoriť subjekt',
    columns: {
      name: 'Meno/Názov',
      partyIdentifier: 'RČ/IČO',
      eic: 'EIC',
      serviceLevel: 'Úroveň služby',
      status: 'Stav účtu',
      validTo: 'Platnosť do'
    },
    filter: {
      status: 'Stav',
      levelCode: 'Úroveň služby',
      validity: 'Platnosť'
    }
  },
  input: {
    EMSPartyName: 'Meno / Názov',
    EMSPartyType: 'Typ subjektu',
    EMSPartyIdentifier: 'RČ / IČO',
    EMSMemberAccountType: 'Rola subjektu',
    ServiceLevelCode: 'Úroveň služieb',
    EnergyMarketParticipantRole: 'Trhová rola',
    ImbalanceResponsibilityMode: 'Zodpovednosť za odchýlku',
    EMSMemberAccountName: 'Meno / Názov',
    EMSMemberAccountEic: 'EIC',
    username: 'Používateľské meno',
    password: 'Heslo',
    clientCertificateFile: 'Presunúť certifikát sem alebo',
    uploadClientCertificateFile: 'kliknutím nahrať',
    certificateMaxSize: 'Maximálna veľkosť súboru je 500 kB',
    fileSize: 'Veľkosť súboru: ',
    fileSizeBytes: ' B',
    MarketParticipantCredentialsType: 'Exterená služba'
  },
  validation: {
    'EMSPartyName-required': 'Meno/názov subjektu je povinný',
    'EMSPartyName-max': 'Prekročená maximálna dĺžka',
    'EMSPartyName-mail': 'Nekorektný formát mena/názvu',
    'EMSPartyName-exists': 'Meno/názov subjektu musí byť unikátny',
    'EMSPartyType-required': 'Typ subjektu je povinný',
    'EMSPartyIdentifier-required': 'RČ/IČO je povinné',
    'EMSPartyIdentifier-matches':
      'RČ/IČO subjektu musí obsahovať maximálne 16 alfanumerických znakov',
    'EMSPartyIdentifier-exists': 'RČ/IČO subjektu musí byť unikátne',
    'EMSMemberAccountName-required': 'Meno/názov účtu subjektu je povinné',
    'EMSMemberAccountType-required': 'Rola subjektu je povinná',
    'ServiceLevelCode-required': 'Úroveň služieb je povinná',
    'EnergyMarketParticipantRole-required': 'Trhová rola je povinná',
    'ImbalanceResponsibilityMode-required':
      'Zodpovednosť za odchýlku je povinná',
    'EMSMemberAccountEic-required': 'EIC je povinné',
    'EMSMemberAccountEic-max': 'Dĺžka musí byť 16 znakov',
    'EMSMemberAccountEic-exists': 'EIC musí byť unikátne',
    'username-required': 'Používateľské meno je povinné',
    'password-required': 'Heslo je povinné',
    'clientCertificateFile-required': 'Certifikát je povinný',
    'MarketParticipantCredentialsType-required': 'Externá služba je povinná'
  }
};

export default skEaiSubjects;
